import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import SettingsActions from 'store/reducers/Settings';
import SupervisorService from 'services/Supervisor';
import CardBox from 'components/theme/CardBox';
import Table from 'components/custom/Table/AsyncTable';
import NewEntityBtn from 'components/custom/NewEntityBtn';
import IntlMessages from 'utils/IntlMessages';
import LicenseEditForm from '../../../../../../../components/LicenseEditForm';

class Dashboard extends React.Component {
  state = {
    data: [],
    editModal: false,
  };

  getData = ( params ) => {
    const { toggleLoading, sessionId } = this.props;
    toggleLoading( true );

    this.params = params;
    SupervisorService.getSupervisorLicensesBySession( sessionId, params )
      .then( ( response ) => {
        toggleLoading( false );

        if ( response.ok ) {
          this.setState( {
            data: response.data.data || [],
            pages: Math.ceil( response.data.total / params.limit ),
            total: response.data.total,
          } );
        }
      } );
  };

  getEntity = ( id ) => {
    const { toggleLoading, sessionId } = this.props;
    toggleLoading( true );

    SupervisorService.getSupervisorLicense( sessionId, id )
      .then( ( response ) => {
        toggleLoading( false );

        if ( response.ok ) {
          this.entityToEdit = response.data;
          this.toggleEditModal();
        }
      } );
  };

  submitForm = ( formData, form ) => {
    const { toggleLoading, toggleAlert, sessionId } = this.props;
    const dataToSend = {};

    toggleLoading( true );
    _.map( _.keys( form.getState().modified ), ( key ) => {
      dataToSend[key] = _.get( formData[key], 'id' ) ? formData[key].id : formData[key];
    } );

    const promise = this.entityToEdit && this.entityToEdit.id
      ? SupervisorService.updateSupervisorLicense( sessionId, this.entityToEdit.id, dataToSend )
      : SupervisorService.saveSupervisorLicense( sessionId, dataToSend );
    promise.then( ( response ) => {
      toggleLoading( false );
      if ( !response.ok ) return toggleAlert( response.errors );

      toggleAlert( 'dataSaved', 'info' );
      this.toggleEditModal();
      this.getData( this.params );
    } );
  };

  toggleEditModal = ( cb ) => {
    this.setState( previousState => ( { editModal: !previousState.editModal } ), cb );
  };

  render() {
    const { editModal, ...rest } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-12 text-right">
            <NewEntityBtn
              label="newProfessorLicense"
              onClick={this.toggleEditModal}
            />
          </div>
        </div>

        <CardBox cardStyle="p-0">
          <Table
            onFetchData={this.getData}
            {...rest}
            columns={[
              {
                maxWidth: 150,
                Header: <IntlMessages id="id" />,
                accessor: 'id',
                Cell: props => ( props.value ? `${props.value.slice( 0, 8 ).toUpperCase()}` : null ),
              },
              {
                Header: <IntlMessages id="user" />,
                accessor: 'user.email',
                id: 'user',
              },
              {
                Header: <IntlMessages id="userEnabled" />,
                accessor: 'user.enabled',
                Cell: props => ( props.value ? <i className="fa fa-check" />
                  : <i className="fa fa-times" /> ),
              },
              {
                Header: <IntlMessages id="lastLogin" />,
                accessor: 'user.lastLogin',
                Cell: props => ( props.value ? moment( Number( props.value ) ).format( 'DD/MM/YYYY HH:mm' ) : null ),
              },
              {
                Header: <IntlMessages id="enabled" />,
                accessor: 'enabled',
                maxWidth: 120,
                Cell: props => ( props.value ? <i className="fa fa-check" />
                  : <i className="fa fa-times" /> ),
              },
              {
                Header: '',
                accessor: 'id',
                maxWidth: 60,
                Cell: props => (
                  <NewEntityBtn
                    isEdit
                    onClick={() => this.getEntity( props.value )}
                  />
                ),
              },
            ]}
          />
        </CardBox>

        <LicenseEditForm
          data={this.entityToEdit}
          open={editModal}
          newLabel="newProfessorLicense"
          editLabel="editProfessorLicense"
          onClose={() => this.toggleEditModal()}
          onSubmit={this.submitForm}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  toggleAlert: SettingsActions.toggleAlert,
  toggleLoading: SettingsActions.toggleLoading,
};

export default connect(
  null,
  mapDispatchToProps,
)( Dashboard );
